import React from 'react'
import s from './ServiceStatusGraph.css'
import colors from 'styles/colors-export.css'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import { lowerCase } from 'lodash'

const getColor = status => {
  if (status === 'Partial Loss') {
    return colors.zOrange
  } else if (status === 'Total Loss') {
    return colors.zRed
  }
  return colors.zGreen
}

export default ({ outages }) => (
  <div className={s.outer}>
    {Object.keys(outages).map(service => {
      const impact = outages[service].impact

      return (
        <div
          className={cn(s.row, sLay['layout-row'], sLay['layout-align-start-center'])}
          key={service}
        >
          <div className={s.dot} style={{ background: getColor(impact) }} />
          {lowerCase(service)}
          <div className={sLay.flex} />
          {impact || 'Functional'}
        </div>
      )
    })}
  </div>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Graphs/ServiceStatusGraph/ServiceStatusGraph.jsx